import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconSortAscSmall(props: IconProps) {
  return (
    <BaseIcon viewBox="0 0 16 16" size={16} {...props}>
      <path
        fill="currentColor"
        d="M10.5 3a.5.5 0 0 1 .5.5v4.793l1.146-1.147a.5.5 0 0 1 .707.708l-2 2a.5.5 0 0 1-.707 0l-2-2a.5.5 0 1 1 .707-.708L10 8.293V3.5a.5.5 0 0 1 .5-.5ZM3 12.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5ZM3.5 9a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3ZM3 6.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5ZM3.5 3a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1Z"
      />
    </BaseIcon>
  );
}
